import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AnonsComponent} from './anons.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [],
  declarations: [
    AnonsComponent
  ],
  exports: [
    AnonsComponent
  ]
})
export class AnonsModule {
}
